import { Controller } from "@hotwired/stimulus";
import { initChameleon, identifyUser } from '../../../chameleon-config';
import chmln from '@chamaeleonidae/chmln';

export default class extends Controller {
    static values = {
        awsEnv: String
    }

    connect() {
        if (this.awsEnvValue == 'production') {
            this.initializeChameleon();
            this.boundTurboLoad = this.handleTurboLoad.bind(this);
            document.addEventListener('turbo:load', this.boundTurboLoad);
            document.addEventListener('turbo:render', this.boundTurboLoad);
        }
    }

    disconnect() {
        if (this.boundTurboLoad) {
            document.removeEventListener('turbo:load', this.boundTurboLoad);
            document.removeEventListener('turbo:render', this.boundTurboLoad);
        }
    }

    handleTurboLoad() {
        this.initializeChameleon();
    }

    initializeChameleon() {
        if (!window.__chameleonInitialized) {
            initChameleon();
            window.__chameleonInitialized = true;
        }

        this.identifyVisitor();

        if (window.chmln && typeof window.chmln.refresh === 'function') {
            window.chmln.refresh();
        }
    }


    identifyVisitor() {
        var uid;
        try { 
            uid = document.cookie.match(/\bvisitor-uid=([a-z0-9-]+)(;|$)/)[1]; 
        } catch(e) {
            document.cookie = 'visitor-uid='+(uid = Math.random().toString(36).substring(2))+'; expires=Tue, Oct 13 2037 04:24:07 UTC; path=/;';
        }

        chmln.identify(uid, { visitor: true });
    }
}